import Vue from 'vue'
import Vuex from 'vuex'
 
Vue.use(Vuex)
 
export default new Vuex.Store({
  state: {
    pageData:{
      isOriginHei: true,
      tabActive: 0,
      activeName: 'a',
      historyList: [],
    }
  },
  actions: {
  
  },
  mutations: {
    newPageData (state, res) {
      state.pageData[res.key] = res.data
    },
  },
  getters: {
    pageData (state) {
      return state.pageData
    },
  }
});


// WEBPACK FOOTER //
// ./src/store/index.js